import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import Strings from '../../../../i18n';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { EditPartNumberTemplateProps } from './editPartNumberTemplateProps';
import { partNumberAction } from '../../../../utils/validators';
import {
  useDeletePartNumberMutation,
  useUpdatePartNumberMutation
} from '../../../../services/manufacture/manufactureService';

export const EditPartNumberSideBar = ({
  partNumber,
  reloadTable,
  setOpenSideBar,
  setUsersSelected,
  openRightSideBarForMethod
}: EditPartNumberTemplateProps) => {
  const [updatePartNumber, { isSuccess }] = useUpdatePartNumberMutation();
  const [deletePartNumber, { isSuccess: isSuccessDelete }] =
    useDeletePartNumberMutation();

  useEffect(() => {
    if (isSuccess) {
      toast.success('Data was updated successfully');
      reloadTable();
      setOpenSideBar(false);
    }
  }, [isSuccess]);

  const deletePartNumberAction = () => {
    if (partNumber?.id) {
      deletePartNumber(partNumber.id);
    }
  };

  useEffect(() => {
    if (isSuccessDelete) {
      toast.success('Data was deleted successfully');
      reloadTable();
      setOpenSideBar(false);
      setUsersSelected([]);
    }
  }, [isSuccessDelete]);

  return (
    partNumber && (
      <Formik
        enableReinitialize
        initialValues={{
          partNumber: partNumber?.partNumber,
          series: partNumber.series,
          product: partNumber.product,
          model: partNumber.model,
          sku: partNumber.sku,
          startSerialNumber: partNumber.startSerialNumber,
          description: partNumber.description
        }}
        onSubmit={(values) => {
          updatePartNumber({
            partNumber: values.partNumber,
            series: values.series,
            product: values.product,
            model: values.model,
            sku: values.sku,
            startSerialNumber: values.startSerialNumber,
            description: values.description,
            id: partNumber.id
          });
        }}
      >
        {() => (
          <>
            <StyledContainerItems>
              <StyledTitleSideBar>
                {Strings.manufacture.partNumber.title}
              </StyledTitleSideBar>
              <SideBarDeleteActionWithPopup
                onDelete={() => deletePartNumberAction()}
                titleConfirmation={
                  Strings.manufacture.partNumber.create.deleteUserTitle
                }
                textConfirmation={Strings.common.thisActionIsIrreversible}
                textIcon={Strings.manufacture.partNumber.create.deletePartLabel}
              />
            </StyledContainerItems>
            <StyledContainerFooterSideBar>
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setOpenSideBar(false);
                  setUsersSelected([]);
                }}
              >
                {Strings.common.cancel}
              </button>
            </StyledContainerFooterSideBar>
          </>
        )}
      </Formik>
    )
  );
};
